import Account from './../Sellpoint/script.js'



export default {
    name: 'Help',
    mixins: [Account],
    data () {
        return {
            
        }
    },

    components: {
        
    },
     
    methods: {

        backTo(){
            window.history.back(); 
        },
      
    },

    created: function(){
        this.loading = true;
        let self = this;
        setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Help/script.js